jQuery(document).ready(function onProductCategorySwitcherReady($) {
    "use strict";

    var puffHeight = $('.single-product')
        .last()
        .height();

    $('.tips-puff').height(puffHeight);
});